angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherClasses', function ($http, $log, EventManager, userAccount, api,  DATA_HOST, PanelFactory, language, apiTranslationService) {
  return {
    templateUrl: 'template.html',
    scope: {
    },
    link: function (scope, element) {

      scope.getTranslation = function(translationId){
        if(active_data && active_data.resource_type === 'embedded_notification'){
          return apiTranslationService.getTranslation(translationId);
        }
        if (translationId){
          return language.get(translationId);
        }
        else{
          return '';
        }
      }

      var eventManager = new EventManager('teacherClasses', scope);
      var active_data;
      eventManager.listen('module:open:resource', function(e, data){        
        scope.active_slug = data.notification_slug ? data.notification_slug : data.slug;
        active_data = data;
        //scope.status.show = true;
      })

      scope.getSlugTrans = function(){
        var trans = '/ ' + scope.getTranslation(scope.active_slug);
        //this part is added for notifications that need the followup flag
        if(active_data && active_data.is_follow_up){
          trans += ' - ' + language.get('follow_up');
        }
        return trans;
      }

      eventManager.listen('module:close:resource', function(e, data){
        //scope.status.show = false;
        scope.active_slug = null;
      })

    }
  }
});
